import {
  SectionLabel,
  SectionRoute,
  YourInformationTaskGroupLabel,
  ApplicationTaskGroupLabel,
  YourInformationTaskLabel,
  ApplicationTaskLabel,
  YourInformationTaskRoute,
  ApplicationTaskRoute,
  RouteConfig,
  OfferTaskLabel,
  OfferTaskRoute,
  OfferTaskGroupLabel,
  ApplicationStatus
} from 'types';

export const applicantTasksConfig: RouteConfig = {
  defaultTask: {
    label: SectionLabel.Home,
    route: SectionRoute.Home
  },
  sections: [
    {
      label: SectionLabel.YourInformation,
      route: SectionRoute.YourInformation,
      taskGroups: [
        {
          label: YourInformationTaskGroupLabel.AboutYou,
          tasks: [
            {
              label: YourInformationTaskLabel.ContactDetails,
              route: YourInformationTaskRoute.ContactDetails
            },
            {
              label: YourInformationTaskLabel.FeeStatus,
              route: YourInformationTaskRoute.FeeStatus
            },
            {
              label: YourInformationTaskLabel.StudyPlans,
              route: YourInformationTaskRoute.StudyPlans
            }
          ]
        },
        {
          label: YourInformationTaskGroupLabel.YourStudyHistory,
          tasks: [
            {
              label: YourInformationTaskLabel.LatestEducation,
              route: YourInformationTaskRoute.LatestEducation
            },
            {
              label: YourInformationTaskLabel.LatestQualifications,
              route: YourInformationTaskRoute.LatestQualifications
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Application,
      route: SectionRoute.Application,
      taskGroups: [
        {
          label: ApplicationTaskGroupLabel.PersonalInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.Identity,
              route: ApplicationTaskRoute.Identity
            },
            {
              label: ApplicationTaskLabel.NationalityResidence,
              route: ApplicationTaskRoute.NationalityResidence
            },
            {
              label: ApplicationTaskLabel.ContactDetails,
              route: ApplicationTaskRoute.ContactDetails
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.QualificationsExperience,
          tasks: [
            {
              label: ApplicationTaskLabel.EducationHistory,
              route: ApplicationTaskRoute.EducationHistory
            },
            {
              label: ApplicationTaskLabel.EnglishLanguage,
              route: ApplicationTaskRoute.EnglishLanguage
            },
            {
              label: ApplicationTaskLabel.Employment,
              route: ApplicationTaskRoute.Employment
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.SupportingInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.References,
              route: ApplicationTaskRoute.References
            },
            {
              label: ApplicationTaskLabel.PersonalStatement,
              route: ApplicationTaskRoute.PersonalStatement
            },
            {
              label: ApplicationTaskLabel.Funding,
              route: ApplicationTaskRoute.Funding
            },
            {
              label: ApplicationTaskLabel.ImmigrationHistory,
              route: ApplicationTaskRoute.ImmigrationHistory
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.AboutYourApplication,
          tasks: [
            {
              label: ApplicationTaskLabel.DiversityInclusion,
              route: ApplicationTaskRoute.DiversityInclusion
            },
            {
              label: ApplicationTaskLabel.Representation,
              route: ApplicationTaskRoute.Representation
            },
            {
              label: ApplicationTaskLabel.Referral,
              route: ApplicationTaskRoute.Referral
            },
            {
              label: ApplicationTaskLabel.Declarations,
              route: ApplicationTaskRoute.Declarations
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.Consent,
          tasks: [
            {
              label: ApplicationTaskLabel.InformationProcessing,
              route: ApplicationTaskRoute.InformationProcessing
            },
            {
              label: ApplicationTaskLabel.PrivacyPolicy,
              route: ApplicationTaskRoute.PrivacyPolicy
            },
            {
              label: ApplicationTaskLabel.TermsConditions,
              route: ApplicationTaskRoute.TermsConditions
            },
            {
              label: ApplicationTaskLabel.AccuracyOfData,
              route: ApplicationTaskRoute.AccuracyOfData
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Offers,
      route: SectionRoute.Offers,
      taskGroups: [
        {
          label: OfferTaskGroupLabel.Acceptance,
          tasks: [
            {
              label: OfferTaskLabel.ConditionalOffer,
              route: OfferTaskRoute.ConditionalOffer
            },
            {
              label: OfferTaskLabel.UnconditionalOffer,
              route: OfferTaskRoute.UnconditionalOffer
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Conditions,
          tasks: [
            {
              label: OfferTaskLabel.Passport,
              route: OfferTaskRoute.Passport
            },
            {
              label: OfferTaskLabel.PhotoID,
              route: OfferTaskRoute.PhotoID
            },
            {
              label: OfferTaskLabel.ProofOfNameChange,
              route: OfferTaskRoute.ProofOfNameChange
            },
            {
              label: OfferTaskLabel.NameAffidavit,
              route: OfferTaskRoute.NameAffidavit
            },
            {
              label: OfferTaskLabel.BirthCert,
              route: OfferTaskRoute.BirthCert
            },
            {
              label: OfferTaskLabel.AcademicResults,
              route: OfferTaskRoute.AcademicResults
            },
            {
              label: OfferTaskLabel.AcademicCertificate,
              route: OfferTaskRoute.AcademicCertificate
            },
            {
              label: OfferTaskLabel.AcademicTranscript,
              route: OfferTaskRoute.AcademicTranscript
            },
            {
              label: OfferTaskLabel.EnglishLanguageResults,
              route: OfferTaskRoute.EnglishLanguageResults
            },
            {
              label: OfferTaskLabel.EnglishLanguageCertificate,
              route: OfferTaskRoute.EnglishLanguageCertificate
            },
            {
              label: OfferTaskLabel.ProofOfManagerialExperience,
              route: OfferTaskRoute.ProofOfManagerialExperience
            },
            {
              label: OfferTaskLabel.ProofOfAddress,
              route: OfferTaskRoute.ProofOfAddress
            },
            {
              label: OfferTaskLabel.CV,
              route: OfferTaskRoute.CV
            },
            {
              label: OfferTaskLabel.ProofOfImmigrationStatus,
              route: OfferTaskRoute.ProofOfImmigrationStatus
            },
            {
              label: OfferTaskLabel.LetterOfRecommendation,
              route: OfferTaskRoute.LetterOfRecommendation
            },
            {
              label: OfferTaskLabel.PersonalStatement,
              route: OfferTaskRoute.PersonalStatement
            },
            {
              label: OfferTaskLabel.CustomRequirement,
              route: OfferTaskRoute.CustomRequirement
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Payment,
          tasks: [
            {
              label: OfferTaskLabel.Payment,
              route: OfferTaskRoute.Payment
            },
            {
              label: OfferTaskLabel.ProofOfPayment,
              route: OfferTaskRoute.ProofOfPayment
            }
          ]
        }
      ]
    }
  ]
};

// same structure just remove /applications/{applicationId} from urls
export const uniViewApplicantTaskGroups = applicantTasksConfig.sections[1].taskGroups.map(taskGroup => {
  const { label, tasks } = taskGroup;
  return {
    label,
    tasks: tasks.map(task => {
      const { label: taskLabel, route } = task;
      return {
        label: taskLabel,
        route: route.replace('/applications/{applicationId}', '')
      };
    })
  };
});

// // same as all urls but has /application/{uni}/{userId}/ at the start
// export const agentViewApplicantTaskGroups = {
//   ...applicantTasksConfig,
//   sections: applicantTasksConfig.sections.map(s => ({
//     ...s,
//     route: `/application/{uni}/{applicantId}${s.route}`,
//     taskGroups: s.taskGroups.map(tg => ({
//       ...tg,
//       tasks: tg.tasks.map(t => ({
//         ...t,
//         route: `/application/{uni}/{applicantId}${t.route}`
//       }))
//     }))
//   }))
// };

export const ActiveApplicationStatues = [
  ApplicationStatus.InProgress,
  ApplicationStatus.Completed,
  ApplicationStatus.Submitted
];
